<template>
  <div>
    <b-card>
      <div
        class="table-header-border-bottom pb-1 mb-md-3 mb-1 d-flex justify-content-between align-items-center"
      >
        <h3 class="mt-1">
          <feather-icon
            icon="UsersIcon"
            class="mr-50"
            style="width: 18px; height: 18px"
          />
          <span>Users</span>
        </h3>
        <div class="d-flex">
          <b-button
            class="gradient-btn mt-md-1 py-md-75 px-md-2"
            :to="{ name: 'users-create' }"
          >
            <feather-icon icon="PlusIcon" />
            <span> Create a user</span>
          </b-button>
        </div>
      </div>
      <b-form
        @submit.prevent="filter"
        class="filters rounded p-1 my-md-1 d-flex align-items-center justify-content-between flex-wrap"
      >
        <div class="col-sm-3 col-12 p-50 d-flex align-items-center">
          <!-- <div class="mr-50">
            <b-form-checkbox v-model="selectAll"></b-form-checkbox>
          </div> -->
          <v-select
            :options="types"
            v-model="type"
            label="label"
            :reduce="(option) => option.value"
            :searchable="false"
            placeholder="Display on the page"
            class="w-100"
          ></v-select>
        </div>

        <div class="col-sm-6 col-12 d-flex align-items-center p-50">
          <b-form-input
            placeholder="search"
            v-model.trim="search"
            :disabled="!type"
          />
        </div>
        <div class="col-sm-3 col-12 p-50">
          <b-button class="w-100" type="submit" :disabled="!search">
            <span class="text-muted h5"> Filtering</span>
          </b-button>
        </div>
      </b-form>
      <data-table
        class="user-component"
        :fields="fields"
        :items="users"
        :loading="loading"
      >
        <template #selectCategories="{ data }">
          <div class="d-flex">
            <div class="pr-50 border-right mr-75">
              <!-- <b-form-checkbox
              v-model="removeCategoriesData"
              :value="data.item.id"
            ></b-form-checkbox> -->
              <span class="font-weight-bold h5 mb-0">{{ data.item.id }}</span>
            </div>
          </div>
        </template>

        <template #name="{ data }">
          <div class="nowrap-white-space">
            <b-avatar
              size="40"
              variant="light-primary"
              rounded="avatar"
              style="border: 2px solid #73747e !important"
              :src="data.item.avatar"
            />
            {{ data.item.first_name + " " + data.item.last_name || "-" }}
          </div>
        </template>

        <template #username="{ data }">
          @{{ data.item.user_name || "-" }}
        </template>

        <template #country="{ data }">
          <div style="height: 35px; width: 40px" v-if="data.item.flag_url">
            <b-img
              class="rounded-circle"
              style="height: 30px !important"
              width="30"
              :src="data.item.flag_url || errorImage"
              @error="setAltImg"
              fluid
            />
          </div>
          <span v-else>-</span>
        </template>
        <template #email="{ data }">
          {{ data.item.email || "-" }}
        </template>
        <template #actions="{ data }">
          <div class="nowrap-white-space">
            <b-dropdown no-caret class="d-flex d-xl-none more-option">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" />
              </template>
              <b-dropdown-item
                variant="flat-warning"
                :to="{
                  name: 'user-wallet-overview',
                  params: {
                    id: data.item.id,
                  },
                }"
              >
                <div class="d-flex align-items-center w-100">
                  <feather-icon icon="BookmarkIcon" class="mr-50" />
                  Wallet
                </div>
              </b-dropdown-item>
              <b-dropdown-item
                variant="flat-primary"
                :to="{
                  name: 'users-edit',
                  params: {
                    id: data.item.id,
                  },
                }"
              >
                <div class="d-flex align-items-center w-100">
                  <feather-icon icon="EditIcon" class="mr-50" />
                  Edit
                </div>
              </b-dropdown-item>
            </b-dropdown>
            <div class="d-xl-flex d-none">
              <b-button
                class="mx-25"
                variant="flat-warning"
                :to="{
                  name: 'user-wallet-overview',
                  params: {
                    id: data.item.id,
                  },
                }"
              >
                <feather-icon icon="BookmarkIcon" />
                Wallet
              </b-button>
              <b-button
                class="mx-25"
                variant="flat-primary"
                :to="{
                  name: 'users-edit',
                  params: {
                    id: data.item.id,
                  },
                }"
              >
                <feather-icon icon="EditIcon" />
                Edit
              </b-button>
              <!-- <b-button
              class="mx-25"
              variant="flat-danger"
              @click="removeUser(data.item)"
            >
              <feather-icon icon="TrashIcon" />
              <span class="ml-50">Delete</span>
            </b-button> -->
            </div>
          </div>
        </template>
      </data-table>

      <div
        class="w-100 d-flex flex-wrap align-items-center justify-content-between"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="lg"
          pills
          class="my-2 d-flex justify-content-center"
        >
        </b-pagination>
      </div>
    </b-card>
  </div>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BPagination,
  BLink,
  BCard,
  BFormCheckbox,
  BForm,
  BFormInput,
  BBadge,
  BAvatar,
  BImg,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VSelect from "vue-select";
import qs from "qs";
export default {
  components: {
    DataTable,
    BButton,
    BModal,
    BCard,
    VBModal,
    BPagination,
    BLink,
    BFormCheckbox,
    BForm,
    BFormInput,
    BBadge,
    BAvatar,
    BImg,
    VSelect,
    BDropdown,
    BDropdownItem,
  },
  data() {
    return {
      selectAll: false,
      removeUsersDataData: [],
      url: "/panel/users",
      pages: [],
      selectedPage: "",
      currentPage: 1,
      loading: false,
      pagination: {},
      types: [
        { label: "First name", value: "first_name" },
        { label: "Last name", value: "last_name" },
        // { label: "User name", value: "username" },
        { label: "Email", value: "email" },
      ],
      type: "",
      search: "",
      fields: [
        { key: "selectusers", label: "Row" },
        { key: "name", label: "Full Name" },
        { key: "username", label: "User Name" },
        { key: "country", label: "Country" },
        { key: "email", label: "Email" },
        { key: "actions", label: "Operation" },
      ],
      users: [],
    };
  },
  directives: {
    "b-modal": VBModal,
  },
  watch: {
    async type(val) {
      this.search = await "";
      if (this.$route.fullPath != "/users") {
        this.$router.push({
          name: "users",
        });
      }
    },
    currentPage(val) {
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "users",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    $route: {
      handler(val) {
        this.removeUsersDataData = [];
        this.getUsers();
      },
      immediate: true,
      deep: true,
    },
    selectAll: {
      handler(val) {
        val
          ? (this.removeUsersDataData = this.users.map((user) => user.id))
          : (this.removeUsersDataData = []);
      },
      immediate: true,
    },
    removeUsersDataData: {
      handler(val) {
        val.length == this.users.length && (this.selectAll = true);
        val.length == 0 && (this.selectAll = false);
      },
      deep: true,
    },
    search(val) {
      if (!val) {
        if (this.$route.query.filter) {
          let filter = {};
          this.$router.push({
            name: "users",
            query: {
              filter,
            },
          });
        }
      }
    },
  },
  created() {
    if (this.$route.query.filter) {
      this.$router.push({
        name: "users",
        query: {},
      });
    }
  },
  methods: {
    filter() {
      if (this.type) {
        let filter = {};
        filter[this.type] = this.search;
        this.$router.push({
          name: "users",
          query: {
            ...this.$route.query,
            filter,
          },
        });
      } else if (this.$route.fullPath != "/users") {
        this.$router.push({
          name: "users",
        });
      }
    },
    removeUser(item) {
      this.$bvModal
        .msgBoxConfirm("Are you sure about deleting this option ?", {
          size: "sm",
          bodyClass: "h5 my-2",
          okVariant: "primary",
          okTitle: "Yes",
          cancelTitle: "No",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.loading = true;
            try {
              await this.$http.delete(`/panel/users/${item.id}`);
              if (!this.$route.query.page || this.$route.query.page == 1) {
                this.removeUsersDataData = [];
                await this.getUsers();
              } else {
                await this.$router.push({
                  name: "users",
                  query: { page: 1 },
                });
                this.currentPage = await this.$route.query.page;
              }
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Your option has been deleted successfully.",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } catch (err) {
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: "There is some problem",
                    icon: "InfoIcon",
                    variant: "danger",
                  },
                },
                { position: "bottom-right" }
              );
            }
            this.loading = false;
          }
        });
    },
    removeUsersData() {
      if (this.removeUsersDataData.length) {
        this.$bvModal
          .msgBoxConfirm("Are you sure about deleting these options ?", {
            size: "sm",
            bodyClass: "h5 my-2",
            okVariant: "primary",
            okTitle: "Yes",
            cancelTitle: "No",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          })
          .then(async (value) => {
            if (value) {
              this.loading = true;
              try {
                await this.removeUsersDataData.map(
                  async (faq) => await this.$http.delete(`/panel/users/${faq}`)
                );
                if (!this.$route.query.page || this.$route.query.page == 1) {
                  this.removeUsersDataData = [];
                  await this.getUsers();
                } else {
                  await this.$router.push({
                    name: "users",
                    query: { page: 1 },
                  });
                  this.currentPage = await this.$route.query.page;
                }
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Your options have been deleted successfully.",
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
              } catch (err) {
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "There is some problem",
                      icon: "InfoIcon",
                      variant: "danger",
                    },
                  },
                  { position: "bottom-right" }
                );
              }
              this.loading = false;
            }
          });
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "No option selected",
              icon: "InfoIcon",
              variant: "danger",
            },
          },
          { position: "bottom-right" }
        );
      }
    },
    async getUsers() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
        };
        const { data } = await this.$http.get(this.url, {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.users = data.data;
        this.pagination = await data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
<style scoped>
@media (max-width: 576px) {
  .btn {
    padding: 14px 5px;
  }
  .btn > span {
    font-size: 12px !important;
  }
  h3 {
    font-size: 18px !important;
  }
}
</style>
